"use client";

import { forwardRef, useState } from "react";

import { Input, type InputProps } from "./input.component";
import { getValidationMessage } from "./input.validation";

export const FormInput = forwardRef<HTMLInputElement, FormInputProps>(
  function FormInput(
    { error, label, onChange, onInput, onInvalid, ...props },
    ref,
  ) {
    const [validationError, setValidationError] = useState<string>();
    const resolvedError = error ?? validationError;

    const handleInvalid: React.InputEventHandler<HTMLInputElement> = (
      event,
    ) => {
      event.preventDefault();
      setValidationError(getValidationMessage(event.currentTarget, label));
      onInvalid?.(event);
    };

    const clearValidationErrorIfValid = (input: HTMLInputElement) => {
      if (validationError && input.validity.valid) {
        setValidationError(undefined);
      }
    };

    const handleInput: React.InputEventHandler<HTMLInputElement> = (event) => {
      clearValidationErrorIfValid(event.currentTarget);
      onInput?.(event);
    };

    const handleChange: React.ChangeEventHandler<HTMLInputElement> = (
      event,
    ) => {
      clearValidationErrorIfValid(event.currentTarget);
      onChange?.(event);
    };

    return (
      <Input
        ref={ref}
        label={label}
        error={resolvedError}
        onChange={handleChange}
        onInput={handleInput}
        onInvalid={handleInvalid}
        {...props}
      />
    );
  },
);

export type FormInputProps = InputProps;
